var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user_list_page" },
    [
      !_vm.isAppNamesLoaded
        ? _c(
            "a-spin",
            {
              staticStyle: {
                display: "block",
                "text-align": "center",
                "margin-top": "100px",
              },
              attrs: { tip: "加载中..." },
            },
            [
              _c("a-icon", {
                staticStyle: { "font-size": "24px" },
                attrs: { type: "loading" },
              }),
            ],
            1
          )
        : _c(
            "business-group",
            {
              ref: "businessGroup",
              attrs: {
                tableConfig: { ..._vm.tableConfig },
                formConfig: { ..._vm.formConfig },
                formValues: _vm.dynamicFormValues,
              },
              scopedSlots: _vm._u([
                {
                  key: "action",
                  fn: function (record) {
                    return [
                      _c(
                        "a-space",
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "link" },
                              on: {
                                click: function ($event) {
                                  return _vm.edit(record)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "tableAction" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                      "align-items": "center",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "a-select",
                          {
                            staticStyle: { width: "300px" },
                            attrs: { placeholder: "请选择appName" },
                            on: { change: _vm.handleAppNameChange },
                            model: {
                              value: _vm.currentAppName,
                              callback: function ($$v) {
                                _vm.currentAppName = $$v
                              },
                              expression: "currentAppName",
                            },
                          },
                          _vm._l(_vm.appNames, function (item) {
                            return _c(
                              "a-select-option",
                              { key: item.name, attrs: { value: item.name } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(item.displayName || item.name) +
                                    " "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-button",
                      { attrs: { type: "primary" }, on: { click: _vm.add } },
                      [
                        _c("a-icon", { attrs: { type: "plus" } }),
                        _vm._v(" 新增 "),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.title,
            maskClosable: false,
            width: "600px",
          },
          on: { ok: _vm.submitForm, cancel: _vm.resetForm },
        },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-col": { span: 6 },
                "wrapper-col": { span: 16 },
              },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "软件名", prop: "name" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        placeholder: "请选择软件名",
                        disabled: !_vm.isAdd,
                      },
                      model: {
                        value: _vm.ruleForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "name", $$v)
                        },
                        expression: "ruleForm.name",
                      },
                    },
                    _vm._l(_vm.appNames, function (item) {
                      return _c(
                        "a-select-option",
                        { key: item.name, attrs: { value: item.name } },
                        [
                          _vm._v(
                            " " + _vm._s(item.displayName || item.name) + " "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "功能描述", prop: "description" } },
                [
                  _c("a-textarea", {
                    attrs: { placeholder: "请输入功能描述", rows: 4 },
                    model: {
                      value: _vm.ruleForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "description", $$v)
                      },
                      expression: "ruleForm.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "安装包上传", prop: "content" } },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "a-upload",
                        {
                          attrs: {
                            name: "file",
                            "before-upload": _vm.beforeUpload,
                            remove: _vm.removeFile,
                            "file-list": _vm.fileList,
                            disabled: _vm.upLoading,
                          },
                        },
                        [
                          _vm.fileList.length === 0 && !_vm.upLoading
                            ? _c(
                                "a-button",
                                [
                                  _c("a-icon", { attrs: { type: "upload" } }),
                                  _vm._v(" 选择文件 "),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.upLoading
                            ? _c(
                                "div",
                                { staticClass: "upload-loading" },
                                [
                                  _c("a-spin", {
                                    attrs: { tip: "上传中... " + _vm.process },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.ruleForm.content &&
                  !_vm.isAdd &&
                  _vm.fileList.length === 0
                    ? _c("div", { staticClass: "current-file-info" }, [
                        _vm._v(" 当前文件："),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.ruleForm.content,
                              target: "_blank",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getCurrentFileName(_vm.ruleForm.content)
                              )
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }